module.exports = __webpack_public_path__ + "media/embeds/icons/powered_by_for_activity-87bb3076758cd55e84704b66221698e0.png";